import PropTypes from 'prop-types';
import React     from 'react';

import * as S                from './cancel-ar-presenter.module.scss';
import { ModalWrapper }      from '../modal-wrapper';
import { ProductName }       from '../../common/product/prod-name';
import { XIcon }             from '../../common/assets/x-icon';
import { Message }           from '../../common/message';
import { useGlobalCtx }      from '../../../context/ctx-hook';
import * as ProductSelectors from '../../../context/selectors/product-selectors';
import { getFullDate }       from '../../../helpers/time-helpers';
import CHAT_ICON             from '../../../assets/imgs/icons/icon-chat.svg';

const timezoneStr = 'America/Los_Angeles';

let weekdayOptions = {
  weekday: 'long',
};

let dateOptions = {
  timeZone: timezoneStr,
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
};

const getDateFormat = (options) => {
  const dateObj = new Intl.DateTimeFormat([], options);
  return dateObj.format();
};

const chatOpenHours = (chatHours) => {
  const curLocalTime = new Date();
  const weekDay = getDateFormat(weekdayOptions);
  const hoursArr = chatHours[weekDay].split(' - ');
  const hoursStart = new Date(getDateFormat(dateOptions) + ' ' + hoursArr[0] + ' GMT-8:00');
  const hoursEnd = new Date(getDateFormat(dateOptions) + ' ' + hoursArr[1] + ' GMT-8:00');

  return (hoursStart <= curLocalTime && hoursEnd >= curLocalTime) ? true : false;
};



const CancelARPresenter = ({
  product,
  message,
  points,
  onClose,
  onSubmit
}) => {
  const {state}         = useGlobalCtx();
  const GENESYS_EXISTS  = (typeof Genesys !== 'undefined');
  const GENESYS_ENABLED = state.ui.chatHours.chatEnabled;
  const GENESYS_OPEN    = chatOpenHours(state.ui.chatHours.chatHours);
  const CAN_GENESYS     = (GENESYS_EXISTS && GENESYS_ENABLED && GENESYS_OPEN);
  

  const {expireOn, productName, tierUriName} = ProductSelectors.getSubscription(state, product);
  const {isDisabled, hasError} = state.modal;

  const NAME       = ProductSelectors.getProductName(state, product);
  const DATE       = getFullDate(expireOn);
  const ABILITY_TO = product === 'billmanager' ? 'schedule payments' : `use your ${productName}`;

  const handleChatClick = React.useCallback(() => {
    // eslint-disable-next-line
    Genesys('command', 'Messenger.open', {});
  }, []);

  return (
    <ModalWrapper heading="Cancel Renewal" onClose={onClose} className={S.cancelModal}>
      <div className={S.modalBody}>
        {hasError && <Message type="GENERIC_ERROR"/>}

        <Message
          className={S.label}
          type="ERROR"
          title="Did you know that..."
          messages={[message]}
        />

        <div className={S.midRow}>
          <div className={`${S.productCard} ${tierUriName}`}>
            <ProductName name={NAME}/>
            <p className={S.renewalMsg}>You will be able to {ABILITY_TO} until {DATE}</p>
          </div>

          {points.length > 0 && (
            <ul>
              {points.map((str, index) => (
                <li key={index}>
                  <XIcon color="#C20631"/>
                  <span>{str}</span>
                </li>
              ))}
            </ul>
          )}
        </div>

        {CAN_GENESYS && (
          <div className={S.genesys}>
            <img src={CHAT_ICON} alt="Message Icon"/>
            <p>
              Before you go, a live support agent is available just one click away,
              <button
                type="button"
                className={S.chatBtn}
                onClick={handleChatClick}
              >chat now</button>
            </p>
          </div>
        )}

        <div className={S.btnRow}>
          <button
            type="button"
            onClick={onSubmit}
            className={S.cancelBtn}
            disabled={isDisabled}
          >I&apos;d still like to Cancel</button>

          <button
            type="button"
            onClick={onClose}
            className={S.contentCTABtn}
            disabled={isDisabled}
          >Keep Renewal On</button>
        </div>
      </div>
    </ModalWrapper>
  );
};

CancelARPresenter.displayName = 'CancelARPresenter';
CancelARPresenter.propTypes   = {
  product: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  points:  PropTypes.arrayOf(PropTypes.string).isRequired,

  onClose:  PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

export { CancelARPresenter };
